import React from "react";
import "./Testimonialsc.css";
import homeownersBg from "../assets/homeowners-bg.png";
import contractorsBg from "../assets/contractors-bg.png";
import architectBg from "../assets/architect-bg.png";
import storiesBg from "../assets/stories-bg.png";
import feedbackBg from "../assets/feedback-bg.png";
const Testimonialsc = () => {
  const homeowners = [
    {
      text: `"After trying several paint brands in Karachi, Glamur Paints stands out for genuine quality at honest prices. Unlike other companies, they don't inflate prices just to offer fake discounts. Their Weather Guard paint has protected our exterior walls for over 5 years now, still looking fresh despite Karachi's harsh coastal weather."`,
      name: "Ahmed Hassan, Homeowner, Karachi",
    },
    {
      text: `"When we renovated our home in Hyderabad, our contractor recommended an expensive brand, but we chose Glamur Paints based on a friend's recommendation. Best decision ever! Their High Class Emulsion gave us the premium finish we wanted at a fraction of the cost. The colors are still vibrant after 3 years."`,
      name: "Fatima Khan, Interior Designer, Hyderabad",
    },
    {
      text: `"As someone who has used many paint brands in Pakistan, I can honestly say Glamur Paints offers the best value for money. Their Plastic Emulsion covers beautifully and doesn't fade like cheaper alternatives. My painter was initially hesitant (probably because of lower commission), but even he admitted the quality was superior."`,
      name: "Muhammad Ali, Property Owner, Sukkur",
    },
  ];

  const contractors = [
    {
      text: `"I've been in the construction business for 15 years, and Glamur Paints consistently delivers professional results. Their products are reliable, coverage is excellent, and my clients are always satisfied. Unlike some painters who recommend based on commission, I recommend based on quality - and Glamur delivers."`,
      name: "Rashid Malik, Contractor, Karachi",
    },
    {
      text: `"Working on a large residential complex in Sindh, we needed paints that could handle the region's climate variations. Glamur's Weather Guard exceeded expectations. No peeling, cracking, or fading after two monsoon seasons. My clients now specifically request Glamur Paints for all projects."`,
      name: "Tariq Construction Company, Larkana",
    },
  ];

  const architect = [
    {
      text: `"For our commercial projects across Pakistan, we specify Glamur Paints because of their consistent quality and wide color range. Their technical support team provides excellent guidance on product selection, and their paints always meet our durability specifications."`,
      name: "Sarah Architectural Consultants, Karachi",
    },
    {
      text: `"Glamur Paints has been our go-to specification for residential projects in Sindh Province for over 8 years. Their products perform reliably in our coastal climate, and clients appreciate the honest pricing structure. No hidden costs or inflated MRPs."`,
      name: "Hassan Design Studio, Hyderabad",
    },
  ];

  const stories = [
    {
      text: `"Our family has been using Glamur Paints since the 1990s. Three generations of quality! When we built our new home in Karachi, there was never any question about which paint brand to choose. Glamur's reputation speaks for itself - 40 years in business says everything about their commitment to quality."`,
      name: "Abdul Rahman Family, Karachi",
    },
    {
      text: `"I manage maintenance for several properties across Sindh Province. Glamur Paints consistently outperforms other brands in terms of durability and weather resistance. Their Aquatic Wall Sealer has saved us thousands in maintenance costs by preventing moisture damage."`,
      name: "Property Management Services, Nawabshah",
    },
  ];

  const feedback = [
    {
      text: `"Just completed painting our new apartment with Glamur's High Class Emulsion. The finish is smooth, colors are exactly as promised, and application was effortless. Best paints in Karachi, hands down!"`,
      name: "Zain Abbas, New Customer, Karachi (2025)",
    },
    {
      text: `"After bad experiences with other paint brands, switching to Glamur was refreshing. Their online store made ordering convenient, delivery was prompt, and the paint quality exceeded expectations. Finally found a trustworthy paint brand in Pakistan!"`,
      name: "Ayesha Malik, Online Customer, Islamabad (2025)",
    },
  ];

  const renderStars = () => "★★★★★";

  return (
    <section className="testimonials-section">
      <div className="testimonials-header">
        <h2>Real Stories From Satisfied Customers Across Pakistan</h2>
        <p>
          For over four decades, Glamur Paints has earned the trust of thousands
          of customers across Pakistan. Here’s what they say about choosing us
          as their preferred paint brand:
        </p>
      </div>

      {/* Homeowners */}
      <div className="testimonial-group">
        <div
          className="testimonial-bg"
          style={{
            backgroundImage: `url(${homeownersBg})`,
          }}
        >
          <h3 className="group-title">Homeowners Testimonials</h3>
          <div className="testimonial-cards">
            {homeowners.map((item, index) => (
              <div key={index} className="testimonial-card">
                <div className="stars">{renderStars()}</div>
                <p className="text">{item.text}</p>
                <p className="name">{item.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contractors */}
      <div className="testimonial2-group2">
        <div
          className="testimonial2-bg2"
          style={{
            backgroundImage: `url(${contractorsBg})`,
          }}
        >
          <h3 className="group2-title2">Professional Contractor’s Reviews</h3>
          <div className="testimonial2-cards2">
            {contractors.map((item, index) => (
              <div key={index} className="testimonial2-card2">
                <div className="stars2">{renderStars()}</div>
                <p className="text2">{item.text}</p>
                <p className="name2">{item.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Architects */}
      <div className="testimonial2-group2">
        <div
          className="testimonial2-bg2"
          style={{
            backgroundImage: `url(${architectBg})`,
          }}
        >
          <h3 className="group2-title2">Architect Testimonials</h3>
          <div className="testimonial2-cards2">
            {architect.map((item, index) => (
              <div key={index} className="testimonial2-card2">
                <div className="stars2">{renderStars()}</div>
                <p className="text2">{item.text}</p>
                <p className="name2">{item.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Stories */}
      <div className="testimonial2-group2">
        <div
          className="testimonial2-bg2"
          style={{
            backgroundImage: `url(${storiesBg})`,
          }}
        >
          <h3 className="group2-title2">Long-Term Customer Stories</h3>
          <div className="testimonial2-cards2">
            {stories.map((item, index) => (
              <div key={index} className="testimonial2-card2">
                <div className="stars2">{renderStars()}</div>
                <p className="text2">{item.text}</p>
                <p className="name2">{item.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Feedback */}
      <div className="testimonial2-group2">
        <div
          className="testimonial2-bg2"
          style={{
            backgroundImage: `url(${feedbackBg})`,
          }}
        >
          <h3 className="group2-title2">Recent Customer Feedback</h3>
          <div className="testimonial2-cards2">
            {feedback.map((item, index) => (
              <div key={index} className="testimonial2-card2">
                <div className="stars2">{renderStars()}</div>
                <p className="text2">{item.text}</p>
                <p className="name2">{item.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonialsc;
